{
  "accessibility": 61696,
  "accessibility-outline": 61697,
  "accessibility-sharp": 61698,
  "add": 61699,
  "add-circle": 61700,
  "add-circle-outline": 61701,
  "add-circle-sharp": 61702,
  "add-outline": 61703,
  "add-sharp": 61704,
  "airplane": 61705,
  "airplane-outline": 61706,
  "airplane-sharp": 61707,
  "alarm": 61708,
  "alarm-outline": 61709,
  "alarm-sharp": 61710,
  "albums": 61711,
  "albums-outline": 61712,
  "albums-sharp": 61713,
  "alert": 61714,
  "alert-circle": 61715,
  "alert-circle-outline": 61716,
  "alert-circle-sharp": 61717,
  "alert-outline": 61718,
  "alert-sharp": 61719,
  "american-football": 61720,
  "american-football-outline": 61721,
  "american-football-sharp": 61722,
  "analytics": 61723,
  "analytics-outline": 61724,
  "analytics-sharp": 61725,
  "aperture": 61726,
  "aperture-outline": 61727,
  "aperture-sharp": 61728,
  "apps": 61729,
  "apps-outline": 61730,
  "apps-sharp": 61731,
  "archive": 61732,
  "archive-outline": 61733,
  "archive-sharp": 61734,
  "arrow-back": 61735,
  "arrow-back-circle": 61736,
  "arrow-back-circle-outline": 61737,
  "arrow-back-circle-sharp": 61738,
  "arrow-back-outline": 61739,
  "arrow-back-sharp": 61740,
  "arrow-down": 61741,
  "arrow-down-circle": 61742,
  "arrow-down-circle-outline": 61743,
  "arrow-down-circle-sharp": 61744,
  "arrow-down-left-box": 63034,
  "arrow-down-left-box-outline": 63035,
  "arrow-down-left-box-sharp": 63036,
  "arrow-down-outline": 61745,
  "arrow-down-right-box": 63037,
  "arrow-down-right-box-outline": 63038,
  "arrow-down-right-box-sharp": 63039,
  "arrow-down-sharp": 61746,
  "arrow-forward": 61747,
  "arrow-forward-circle": 61748,
  "arrow-forward-circle-outline": 61749,
  "arrow-forward-circle-sharp": 61750,
  "arrow-forward-outline": 61751,
  "arrow-forward-sharp": 61752,
  "arrow-redo": 61753,
  "arrow-redo-circle": 61754,
  "arrow-redo-circle-outline": 61755,
  "arrow-redo-circle-sharp": 61756,
  "arrow-redo-outline": 61757,
  "arrow-redo-sharp": 61758,
  "arrow-undo": 61759,
  "arrow-undo-circle": 61760,
  "arrow-undo-circle-outline": 61761,
  "arrow-undo-circle-sharp": 61762,
  "arrow-undo-outline": 61763,
  "arrow-undo-sharp": 61764,
  "arrow-up": 61765,
  "arrow-up-circle": 61766,
  "arrow-up-circle-outline": 61767,
  "arrow-up-circle-sharp": 61768,
  "arrow-up-left-box": 63040,
  "arrow-up-left-box-outline": 63041,
  "arrow-up-left-box-sharp": 63042,
  "arrow-up-outline": 61769,
  "arrow-up-right-box": 63043,
  "arrow-up-right-box-outline": 63044,
  "arrow-up-right-box-sharp": 63045,
  "arrow-up-sharp": 61770,
  "at": 61771,
  "at-circle": 61772,
  "at-circle-outline": 61773,
  "at-circle-sharp": 61774,
  "at-outline": 61775,
  "at-sharp": 61776,
  "attach": 61777,
  "attach-outline": 61778,
  "attach-sharp": 61779,
  "backspace": 61780,
  "backspace-outline": 61781,
  "backspace-sharp": 61782,
  "bag": 61783,
  "bag-add": 61784,
  "bag-add-outline": 61785,
  "bag-add-sharp": 61786,
  "bag-check": 61787,
  "bag-check-outline": 61788,
  "bag-check-sharp": 61789,
  "bag-handle": 61790,
  "bag-handle-outline": 61791,
  "bag-handle-sharp": 61792,
  "bag-outline": 61793,
  "bag-remove": 61794,
  "bag-remove-outline": 61795,
  "bag-remove-sharp": 61796,
  "bag-sharp": 61797,
  "balloon": 61798,
  "balloon-outline": 61799,
  "balloon-sharp": 61800,
  "ban": 61801,
  "ban-outline": 61802,
  "ban-sharp": 61803,
  "bandage": 61804,
  "bandage-outline": 61805,
  "bandage-sharp": 61806,
  "bar-chart": 61807,
  "bar-chart-outline": 61808,
  "bar-chart-sharp": 61809,
  "barbell": 61810,
  "barbell-outline": 61811,
  "barbell-sharp": 61812,
  "barcode": 61813,
  "barcode-outline": 61814,
  "barcode-sharp": 61815,
  "baseball": 61816,
  "baseball-outline": 61817,
  "baseball-sharp": 61818,
  "basket": 61819,
  "basket-outline": 61820,
  "basket-sharp": 61821,
  "basketball": 61822,
  "basketball-outline": 61823,
  "basketball-sharp": 61824,
  "battery-charging": 61825,
  "battery-charging-outline": 61826,
  "battery-charging-sharp": 61827,
  "battery-dead": 61828,
  "battery-dead-outline": 61829,
  "battery-dead-sharp": 61830,
  "battery-full": 61831,
  "battery-full-outline": 61832,
  "battery-full-sharp": 61833,
  "battery-half": 61834,
  "battery-half-outline": 61835,
  "battery-half-sharp": 61836,
  "beaker": 61837,
  "beaker-outline": 61838,
  "beaker-sharp": 61839,
  "bed": 61840,
  "bed-outline": 61841,
  "bed-sharp": 61842,
  "beer": 61843,
  "beer-outline": 61844,
  "beer-sharp": 61845,
  "bicycle": 61846,
  "bicycle-outline": 61847,
  "bicycle-sharp": 61848,
  "binoculars": 63046,
  "binoculars-outline": 63047,
  "binoculars-sharp": 63048,
  "bluetooth": 61849,
  "bluetooth-outline": 61850,
  "bluetooth-sharp": 61851,
  "boat": 61852,
  "boat-outline": 61853,
  "boat-sharp": 61854,
  "body": 61855,
  "body-outline": 61856,
  "body-sharp": 61857,
  "bonfire": 61858,
  "bonfire-outline": 61859,
  "bonfire-sharp": 61860,
  "book": 61861,
  "book-outline": 61862,
  "book-sharp": 61863,
  "bookmark": 61864,
  "bookmark-outline": 61865,
  "bookmark-sharp": 61866,
  "bookmarks": 61867,
  "bookmarks-outline": 61868,
  "bookmarks-sharp": 61869,
  "bowling-ball": 61870,
  "bowling-ball-outline": 61871,
  "bowling-ball-sharp": 61872,
  "briefcase": 61873,
  "briefcase-outline": 61874,
  "briefcase-sharp": 61875,
  "browsers": 61876,
  "browsers-outline": 61877,
  "browsers-sharp": 61878,
  "brush": 61879,
  "brush-outline": 61880,
  "brush-sharp": 61881,
  "bug": 61882,
  "bug-outline": 61883,
  "bug-sharp": 61884,
  "build": 61885,
  "build-outline": 61886,
  "build-sharp": 61887,
  "bulb": 61888,
  "bulb-outline": 61889,
  "bulb-sharp": 61890,
  "bus": 61891,
  "bus-outline": 61892,
  "bus-sharp": 61893,
  "business": 61894,
  "business-outline": 61895,
  "business-sharp": 61896,
  "cafe": 61897,
  "cafe-outline": 61898,
  "cafe-sharp": 61899,
  "calculator": 61900,
  "calculator-outline": 61901,
  "calculator-sharp": 61902,
  "calendar": 61903,
  "calendar-clear": 61904,
  "calendar-clear-outline": 61905,
  "calendar-clear-sharp": 61906,
  "calendar-number": 61907,
  "calendar-number-outline": 61908,
  "calendar-number-sharp": 61909,
  "calendar-outline": 61910,
  "calendar-sharp": 61911,
  "call": 61912,
  "call-outline": 61913,
  "call-sharp": 61914,
  "camera": 61915,
  "camera-outline": 61916,
  "camera-reverse": 61917,
  "camera-reverse-outline": 61918,
  "camera-reverse-sharp": 61919,
  "camera-sharp": 61920,
  "car": 61921,
  "car-outline": 61922,
  "car-sharp": 61923,
  "car-sport": 61924,
  "car-sport-outline": 61925,
  "car-sport-sharp": 61926,
  "card": 61927,
  "card-outline": 61928,
  "card-sharp": 61929,
  "caret-back": 61930,
  "caret-back-circle": 61931,
  "caret-back-circle-outline": 61932,
  "caret-back-circle-sharp": 61933,
  "caret-back-outline": 61934,
  "caret-back-sharp": 61935,
  "caret-down": 61936,
  "caret-down-circle": 61937,
  "caret-down-circle-outline": 61938,
  "caret-down-circle-sharp": 61939,
  "caret-down-outline": 61940,
  "caret-down-sharp": 61941,
  "caret-forward": 61942,
  "caret-forward-circle": 61943,
  "caret-forward-circle-outline": 61944,
  "caret-forward-circle-sharp": 61945,
  "caret-forward-outline": 61946,
  "caret-forward-sharp": 61947,
  "caret-up": 61948,
  "caret-up-circle": 61949,
  "caret-up-circle-outline": 61950,
  "caret-up-circle-sharp": 61951,
  "caret-up-outline": 61952,
  "caret-up-sharp": 61953,
  "cart": 61954,
  "cart-outline": 61955,
  "cart-sharp": 61956,
  "cash": 61957,
  "cash-outline": 61958,
  "cash-sharp": 61959,
  "cellular": 61960,
  "cellular-outline": 61961,
  "cellular-sharp": 61962,
  "chatbox": 61963,
  "chatbox-ellipses": 61964,
  "chatbox-ellipses-outline": 61965,
  "chatbox-ellipses-sharp": 61966,
  "chatbox-outline": 61967,
  "chatbox-sharp": 61968,
  "chatbubble": 61969,
  "chatbubble-ellipses": 61970,
  "chatbubble-ellipses-outline": 61971,
  "chatbubble-ellipses-sharp": 61972,
  "chatbubble-outline": 61973,
  "chatbubble-sharp": 61974,
  "chatbubbles": 61975,
  "chatbubbles-outline": 61976,
  "chatbubbles-sharp": 61977,
  "checkbox": 61978,
  "checkbox-outline": 61979,
  "checkbox-sharp": 61980,
  "checkmark": 61981,
  "checkmark-circle": 61982,
  "checkmark-circle-outline": 61983,
  "checkmark-circle-sharp": 61984,
  "checkmark-done": 61985,
  "checkmark-done-circle": 61986,
  "checkmark-done-circle-outline": 61987,
  "checkmark-done-circle-sharp": 61988,
  "checkmark-done-outline": 61989,
  "checkmark-done-sharp": 61990,
  "checkmark-outline": 61991,
  "checkmark-sharp": 61992,
  "chevron-back": 61993,
  "chevron-back-circle": 61994,
  "chevron-back-circle-outline": 61995,
  "chevron-back-circle-sharp": 61996,
  "chevron-back-outline": 61997,
  "chevron-back-sharp": 61998,
  "chevron-collapse": 61999,
  "chevron-collapse-outline": 62000,
  "chevron-collapse-sharp": 62001,
  "chevron-down": 62002,
  "chevron-down-circle": 62003,
  "chevron-down-circle-outline": 62004,
  "chevron-down-circle-sharp": 62005,
  "chevron-down-outline": 62006,
  "chevron-down-sharp": 62007,
  "chevron-expand": 62008,
  "chevron-expand-outline": 62009,
  "chevron-expand-sharp": 62010,
  "chevron-forward": 62011,
  "chevron-forward-circle": 62012,
  "chevron-forward-circle-outline": 62013,
  "chevron-forward-circle-sharp": 62014,
  "chevron-forward-outline": 62015,
  "chevron-forward-sharp": 62016,
  "chevron-up": 62017,
  "chevron-up-circle": 62018,
  "chevron-up-circle-outline": 62019,
  "chevron-up-circle-sharp": 62020,
  "chevron-up-outline": 62021,
  "chevron-up-sharp": 62022,
  "clipboard": 62023,
  "clipboard-outline": 62024,
  "clipboard-sharp": 62025,
  "close": 62026,
  "close-circle": 62027,
  "close-circle-outline": 62028,
  "close-circle-sharp": 62029,
  "close-outline": 62030,
  "close-sharp": 62031,
  "cloud": 62032,
  "cloud-circle": 62033,
  "cloud-circle-outline": 62034,
  "cloud-circle-sharp": 62035,
  "cloud-done": 62036,
  "cloud-done-outline": 62037,
  "cloud-done-sharp": 62038,
  "cloud-download": 62039,
  "cloud-download-outline": 62040,
  "cloud-download-sharp": 62041,
  "cloud-offline": 62042,
  "cloud-offline-outline": 62043,
  "cloud-offline-sharp": 62044,
  "cloud-outline": 62045,
  "cloud-sharp": 62046,
  "cloud-upload": 62047,
  "cloud-upload-outline": 62048,
  "cloud-upload-sharp": 62049,
  "cloudy": 62050,
  "cloudy-night": 62051,
  "cloudy-night-outline": 62052,
  "cloudy-night-sharp": 62053,
  "cloudy-outline": 62054,
  "cloudy-sharp": 62055,
  "code": 62056,
  "code-download": 62057,
  "code-download-outline": 62058,
  "code-download-sharp": 62059,
  "code-outline": 62060,
  "code-sharp": 62061,
  "code-slash": 62062,
  "code-slash-outline": 62063,
  "code-slash-sharp": 62064,
  "code-working": 62065,
  "code-working-outline": 62066,
  "code-working-sharp": 62067,
  "cog": 62068,
  "cog-outline": 62069,
  "cog-sharp": 62070,
  "color-fill": 62071,
  "color-fill-outline": 62072,
  "color-fill-sharp": 62073,
  "color-filter": 62074,
  "color-filter-outline": 62075,
  "color-filter-sharp": 62076,
  "color-palette": 62077,
  "color-palette-outline": 62078,
  "color-palette-sharp": 62079,
  "color-wand": 62080,
  "color-wand-outline": 62081,
  "color-wand-sharp": 62082,
  "compass": 62083,
  "compass-outline": 62084,
  "compass-sharp": 62085,
  "construct": 62086,
  "construct-outline": 62087,
  "construct-sharp": 62088,
  "contract": 62089,
  "contract-outline": 62090,
  "contract-sharp": 62091,
  "contrast": 62092,
  "contrast-outline": 62093,
  "contrast-sharp": 62094,
  "copy": 62095,
  "copy-outline": 62096,
  "copy-sharp": 62097,
  "create": 62098,
  "create-outline": 62099,
  "create-sharp": 62100,
  "crop": 62101,
  "crop-outline": 62102,
  "crop-sharp": 62103,
  "cube": 62104,
  "cube-outline": 62105,
  "cube-sharp": 62106,
  "cut": 62107,
  "cut-outline": 62108,
  "cut-sharp": 62109,
  "desktop": 62110,
  "desktop-outline": 62111,
  "desktop-sharp": 62112,
  "diamond": 62113,
  "diamond-outline": 62114,
  "diamond-sharp": 62115,
  "dice": 62116,
  "dice-outline": 62117,
  "dice-sharp": 62118,
  "disc": 62119,
  "disc-outline": 62120,
  "disc-sharp": 62121,
  "document": 62122,
  "document-attach": 62123,
  "document-attach-outline": 62124,
  "document-attach-sharp": 62125,
  "document-lock": 62126,
  "document-lock-outline": 62127,
  "document-lock-sharp": 62128,
  "document-outline": 62129,
  "document-sharp": 62130,
  "document-text": 62131,
  "document-text-outline": 62132,
  "document-text-sharp": 62133,
  "documents": 62134,
  "documents-outline": 62135,
  "documents-sharp": 62136,
  "download": 62137,
  "download-outline": 62138,
  "download-sharp": 62139,
  "duplicate": 62140,
  "duplicate-outline": 62141,
  "duplicate-sharp": 62142,
  "ear": 62143,
  "ear-outline": 62144,
  "ear-sharp": 62145,
  "earth": 62146,
  "earth-outline": 62147,
  "earth-sharp": 62148,
  "easel": 62149,
  "easel-outline": 62150,
  "easel-sharp": 62151,
  "egg": 62152,
  "egg-outline": 62153,
  "egg-sharp": 62154,
  "ellipse": 62155,
  "ellipse-outline": 62156,
  "ellipse-sharp": 62157,
  "ellipsis-horizontal": 62158,
  "ellipsis-horizontal-circle": 62159,
  "ellipsis-horizontal-circle-outline": 62160,
  "ellipsis-horizontal-circle-sharp": 62161,
  "ellipsis-horizontal-outline": 62162,
  "ellipsis-horizontal-sharp": 62163,
  "ellipsis-vertical": 62164,
  "ellipsis-vertical-circle": 62165,
  "ellipsis-vertical-circle-outline": 62166,
  "ellipsis-vertical-circle-sharp": 62167,
  "ellipsis-vertical-outline": 62168,
  "ellipsis-vertical-sharp": 62169,
  "enter": 62170,
  "enter-outline": 62171,
  "enter-sharp": 62172,
  "exit": 62173,
  "exit-outline": 62174,
  "exit-sharp": 62175,
  "expand": 62176,
  "expand-outline": 62177,
  "expand-sharp": 62178,
  "extension-puzzle": 62179,
  "extension-puzzle-outline": 62180,
  "extension-puzzle-sharp": 62181,
  "eye": 62182,
  "eye-off": 62183,
  "eye-off-outline": 62184,
  "eye-off-sharp": 62185,
  "eye-outline": 62186,
  "eye-sharp": 62187,
  "eyedrop": 62188,
  "eyedrop-outline": 62189,
  "eyedrop-sharp": 62190,
  "fast-food": 62191,
  "fast-food-outline": 62192,
  "fast-food-sharp": 62193,
  "female": 62194,
  "female-outline": 62195,
  "female-sharp": 62196,
  "file-tray": 62197,
  "file-tray-full": 62198,
  "file-tray-full-outline": 62199,
  "file-tray-full-sharp": 62200,
  "file-tray-outline": 62201,
  "file-tray-sharp": 62202,
  "file-tray-stacked": 62203,
  "file-tray-stacked-outline": 62204,
  "file-tray-stacked-sharp": 62205,
  "film": 62206,
  "film-outline": 62207,
  "film-sharp": 62208,
  "filter": 62209,
  "filter-circle": 62210,
  "filter-circle-outline": 62211,
  "filter-circle-sharp": 62212,
  "filter-outline": 62213,
  "filter-sharp": 62214,
  "finger-print": 62215,
  "finger-print-outline": 62216,
  "finger-print-sharp": 62217,
  "fish": 62218,
  "fish-outline": 62219,
  "fish-sharp": 62220,
  "fitness": 62221,
  "fitness-outline": 62222,
  "fitness-sharp": 62223,
  "flag": 62224,
  "flag-outline": 62225,
  "flag-sharp": 62226,
  "flame": 62227,
  "flame-outline": 62228,
  "flame-sharp": 62229,
  "flash": 62230,
  "flash-off": 62231,
  "flash-off-outline": 62232,
  "flash-off-sharp": 62233,
  "flash-outline": 62234,
  "flash-sharp": 62235,
  "flashlight": 62236,
  "flashlight-outline": 62237,
  "flashlight-sharp": 62238,
  "flask": 62239,
  "flask-outline": 62240,
  "flask-sharp": 62241,
  "flower": 62242,
  "flower-outline": 62243,
  "flower-sharp": 62244,
  "folder": 62245,
  "folder-open": 62246,
  "folder-open-outline": 62247,
  "folder-open-sharp": 62248,
  "folder-outline": 62249,
  "folder-sharp": 62250,
  "football": 62251,
  "football-outline": 62252,
  "football-sharp": 62253,
  "footsteps": 62254,
  "footsteps-outline": 62255,
  "footsteps-sharp": 62256,
  "funnel": 62257,
  "funnel-outline": 62258,
  "funnel-sharp": 62259,
  "game-controller": 62260,
  "game-controller-outline": 62261,
  "game-controller-sharp": 62262,
  "gift": 62263,
  "gift-outline": 62264,
  "gift-sharp": 62265,
  "git-branch": 62266,
  "git-branch-outline": 62267,
  "git-branch-sharp": 62268,
  "git-commit": 62269,
  "git-commit-outline": 62270,
  "git-commit-sharp": 62271,
  "git-compare": 62272,
  "git-compare-outline": 62273,
  "git-compare-sharp": 62274,
  "git-merge": 62275,
  "git-merge-outline": 62276,
  "git-merge-sharp": 62277,
  "git-network": 62278,
  "git-network-outline": 62279,
  "git-network-sharp": 62280,
  "git-pull-request": 62281,
  "git-pull-request-outline": 62282,
  "git-pull-request-sharp": 62283,
  "glasses": 62284,
  "glasses-outline": 62285,
  "glasses-sharp": 62286,
  "globe": 62287,
  "globe-outline": 62288,
  "globe-sharp": 62289,
  "golf": 62290,
  "golf-outline": 62291,
  "golf-sharp": 62292,
  "grid": 62293,
  "grid-outline": 62294,
  "grid-sharp": 62295,
  "hammer": 62296,
  "hammer-outline": 62297,
  "hammer-sharp": 62298,
  "hand-left": 62299,
  "hand-left-outline": 62300,
  "hand-left-sharp": 62301,
  "hand-right": 62302,
  "hand-right-outline": 62303,
  "hand-right-sharp": 62304,
  "happy": 62305,
  "happy-outline": 62306,
  "happy-sharp": 62307,
  "hardware-chip": 62308,
  "hardware-chip-outline": 62309,
  "hardware-chip-sharp": 62310,
  "headset": 62311,
  "headset-outline": 62312,
  "headset-sharp": 62313,
  "heart": 62314,
  "heart-circle": 62315,
  "heart-circle-outline": 62316,
  "heart-circle-sharp": 62317,
  "heart-dislike": 62318,
  "heart-dislike-circle": 62319,
  "heart-dislike-circle-outline": 62320,
  "heart-dislike-circle-sharp": 62321,
  "heart-dislike-outline": 62322,
  "heart-dislike-sharp": 62323,
  "heart-half": 62324,
  "heart-half-outline": 62325,
  "heart-half-sharp": 62326,
  "heart-outline": 62327,
  "heart-sharp": 62328,
  "help": 62329,
  "help-buoy": 62330,
  "help-buoy-outline": 62331,
  "help-buoy-sharp": 62332,
  "help-circle": 62333,
  "help-circle-outline": 62334,
  "help-circle-sharp": 62335,
  "help-outline": 62336,
  "help-sharp": 62337,
  "home": 62338,
  "home-outline": 62339,
  "home-sharp": 62340,
  "hourglass": 62341,
  "hourglass-outline": 62342,
  "hourglass-sharp": 62343,
  "ice-cream": 62344,
  "ice-cream-outline": 62345,
  "ice-cream-sharp": 62346,
  "id-card": 62347,
  "id-card-outline": 62348,
  "id-card-sharp": 62349,
  "image": 62350,
  "image-outline": 62351,
  "image-sharp": 62352,
  "images": 62353,
  "images-outline": 62354,
  "images-sharp": 62355,
  "infinite": 62356,
  "infinite-outline": 62357,
  "infinite-sharp": 62358,
  "information": 62359,
  "information-circle": 62360,
  "information-circle-outline": 62361,
  "information-circle-sharp": 62362,
  "information-outline": 62363,
  "information-sharp": 62364,
  "invert-mode": 62365,
  "invert-mode-outline": 62366,
  "invert-mode-sharp": 62367,
  "journal": 62368,
  "journal-outline": 62369,
  "journal-sharp": 62370,
  "key": 62371,
  "key-outline": 62372,
  "key-sharp": 62373,
  "keypad": 62374,
  "keypad-outline": 62375,
  "keypad-sharp": 62376,
  "language": 62377,
  "language-outline": 62378,
  "language-sharp": 62379,
  "laptop": 62380,
  "laptop-outline": 62381,
  "laptop-sharp": 62382,
  "layers": 62383,
  "layers-outline": 62384,
  "layers-sharp": 62385,
  "leaf": 62386,
  "leaf-outline": 62387,
  "leaf-sharp": 62388,
  "library": 62389,
  "library-outline": 62390,
  "library-sharp": 62391,
  "link": 62392,
  "link-outline": 62393,
  "link-sharp": 62394,
  "list": 62395,
  "list-circle": 62396,
  "list-circle-outline": 62397,
  "list-circle-sharp": 62398,
  "list-outline": 62399,
  "list-sharp": 62400,
  "locate": 62401,
  "locate-outline": 62402,
  "locate-sharp": 62403,
  "location": 62404,
  "location-outline": 62405,
  "location-sharp": 62406,
  "lock-closed": 62407,
  "lock-closed-outline": 62408,
  "lock-closed-sharp": 62409,
  "lock-open": 62410,
  "lock-open-outline": 62411,
  "lock-open-sharp": 62412,
  "log-in": 62413,
  "log-in-outline": 62414,
  "log-in-sharp": 62415,
  "log-out": 62416,
  "log-out-outline": 62417,
  "log-out-sharp": 62418,
  "logo-alipay": 62419,
  "logo-amazon": 62420,
  "logo-amplify": 62421,
  "logo-android": 62422,
  "logo-angular": 62423,
  "logo-appflow": 63049,
  "logo-apple": 62424,
  "logo-apple-appstore": 62425,
  "logo-apple-ar": 62426,
  "logo-behance": 62427,
  "logo-bitbucket": 62428,
  "logo-bitcoin": 62429,
  "logo-buffer": 62430,
  "logo-capacitor": 62431,
  "logo-chrome": 62432,
  "logo-closed-captioning": 62433,
  "logo-codepen": 62434,
  "logo-css3": 62435,
  "logo-designernews": 62436,
  "logo-deviantart": 62437,
  "logo-discord": 62438,
  "logo-docker": 62439,
  "logo-dribbble": 62440,
  "logo-dropbox": 62441,
  "logo-edge": 62442,
  "logo-electron": 62443,
  "logo-euro": 62444,
  "logo-facebook": 62445,
  "logo-figma": 62446,
  "logo-firebase": 62447,
  "logo-firefox": 62448,
  "logo-flickr": 62449,
  "logo-foursquare": 62450,
  "logo-github": 62451,
  "logo-gitlab": 62452,
  "logo-google": 62453,
  "logo-google-playstore": 62454,
  "logo-hackernews": 62455,
  "logo-html5": 62456,
  "logo-instagram": 62457,
  "logo-ionic": 62458,
  "logo-ionitron": 62459,
  "logo-javascript": 62460,
  "logo-laravel": 62461,
  "logo-linkedin": 62462,
  "logo-markdown": 62463,
  "logo-mastodon": 62464,
  "logo-medium": 62465,
  "logo-microsoft": 62466,
  "logo-no-smoking": 62467,
  "logo-nodejs": 62468,
  "logo-npm": 62469,
  "logo-octocat": 62470,
  "logo-paypal": 62471,
  "logo-pinterest": 62472,
  "logo-playstation": 62473,
  "logo-pwa": 62474,
  "logo-python": 62475,
  "logo-react": 62476,
  "logo-reddit": 62477,
  "logo-rss": 62478,
  "logo-sass": 62479,
  "logo-skype": 62480,
  "logo-slack": 62481,
  "logo-snapchat": 62482,
  "logo-soundcloud": 62483,
  "logo-stackoverflow": 62484,
  "logo-steam": 62485,
  "logo-stencil": 62486,
  "logo-tableau": 62487,
  "logo-threads": 63052,
  "logo-tiktok": 62488,
  "logo-trapeze": 63050,
  "logo-tumblr": 62489,
  "logo-tux": 62490,
  "logo-twitch": 62491,
  "logo-twitter": 62492,
  "logo-usd": 62493,
  "logo-venmo": 62494,
  "logo-vercel": 62495,
  "logo-vimeo": 62496,
  "logo-vk": 62497,
  "logo-vue": 62498,
  "logo-web-component": 62499,
  "logo-wechat": 62500,
  "logo-whatsapp": 62501,
  "logo-windows": 62502,
  "logo-wordpress": 62503,
  "logo-x": 63051,
  "logo-xbox": 62504,
  "logo-xing": 62505,
  "logo-yahoo": 62506,
  "logo-yen": 62507,
  "logo-youtube": 62508,
  "magnet": 62509,
  "magnet-outline": 62510,
  "magnet-sharp": 62511,
  "mail": 62512,
  "mail-open": 62513,
  "mail-open-outline": 62514,
  "mail-open-sharp": 62515,
  "mail-outline": 62516,
  "mail-sharp": 62517,
  "mail-unread": 62518,
  "mail-unread-outline": 62519,
  "mail-unread-sharp": 62520,
  "male": 62521,
  "male-female": 62522,
  "male-female-outline": 62523,
  "male-female-sharp": 62524,
  "male-outline": 62525,
  "male-sharp": 62526,
  "man": 62527,
  "man-outline": 62528,
  "man-sharp": 62529,
  "map": 62530,
  "map-outline": 62531,
  "map-sharp": 62532,
  "medal": 62533,
  "medal-outline": 62534,
  "medal-sharp": 62535,
  "medical": 62536,
  "medical-outline": 62537,
  "medical-sharp": 62538,
  "medkit": 62539,
  "medkit-outline": 62540,
  "medkit-sharp": 62541,
  "megaphone": 62542,
  "megaphone-outline": 62543,
  "megaphone-sharp": 62544,
  "menu": 62545,
  "menu-outline": 62546,
  "menu-sharp": 62547,
  "mic": 62548,
  "mic-circle": 62549,
  "mic-circle-outline": 62550,
  "mic-circle-sharp": 62551,
  "mic-off": 62552,
  "mic-off-circle": 62553,
  "mic-off-circle-outline": 62554,
  "mic-off-circle-sharp": 62555,
  "mic-off-outline": 62556,
  "mic-off-sharp": 62557,
  "mic-outline": 62558,
  "mic-sharp": 62559,
  "moon": 62560,
  "moon-outline": 62561,
  "moon-sharp": 62562,
  "move": 62563,
  "move-outline": 62564,
  "move-sharp": 62565,
  "musical-note": 62566,
  "musical-note-outline": 62567,
  "musical-note-sharp": 62568,
  "musical-notes": 62569,
  "musical-notes-outline": 62570,
  "musical-notes-sharp": 62571,
  "navigate": 62572,
  "navigate-circle": 62573,
  "navigate-circle-outline": 62574,
  "navigate-circle-sharp": 62575,
  "navigate-outline": 62576,
  "navigate-sharp": 62577,
  "newspaper": 62578,
  "newspaper-outline": 62579,
  "newspaper-sharp": 62580,
  "notifications": 62581,
  "notifications-circle": 62582,
  "notifications-circle-outline": 62583,
  "notifications-circle-sharp": 62584,
  "notifications-off": 62585,
  "notifications-off-circle": 62586,
  "notifications-off-circle-outline": 62587,
  "notifications-off-circle-sharp": 62588,
  "notifications-off-outline": 62589,
  "notifications-off-sharp": 62590,
  "notifications-outline": 62591,
  "notifications-sharp": 62592,
  "nuclear": 62593,
  "nuclear-outline": 62594,
  "nuclear-sharp": 62595,
  "nutrition": 62596,
  "nutrition-outline": 62597,
  "nutrition-sharp": 62598,
  "open": 62599,
  "open-outline": 62600,
  "open-sharp": 62601,
  "options": 62602,
  "options-outline": 62603,
  "options-sharp": 62604,
  "paper-plane": 62605,
  "paper-plane-outline": 62606,
  "paper-plane-sharp": 62607,
  "partly-sunny": 62608,
  "partly-sunny-outline": 62609,
  "partly-sunny-sharp": 62610,
  "pause": 62611,
  "pause-circle": 62612,
  "pause-circle-outline": 62613,
  "pause-circle-sharp": 62614,
  "pause-outline": 62615,
  "pause-sharp": 62616,
  "paw": 62617,
  "paw-outline": 62618,
  "paw-sharp": 62619,
  "pencil": 62620,
  "pencil-outline": 62621,
  "pencil-sharp": 62622,
  "people": 62623,
  "people-circle": 62624,
  "people-circle-outline": 62625,
  "people-circle-sharp": 62626,
  "people-outline": 62627,
  "people-sharp": 62628,
  "person": 62629,
  "person-add": 62630,
  "person-add-outline": 62631,
  "person-add-sharp": 62632,
  "person-circle": 62633,
  "person-circle-outline": 62634,
  "person-circle-sharp": 62635,
  "person-outline": 62636,
  "person-remove": 62637,
  "person-remove-outline": 62638,
  "person-remove-sharp": 62639,
  "person-sharp": 62640,
  "phone-landscape": 62641,
  "phone-landscape-outline": 62642,
  "phone-landscape-sharp": 62643,
  "phone-portrait": 62644,
  "phone-portrait-outline": 62645,
  "phone-portrait-sharp": 62646,
  "pie-chart": 62647,
  "pie-chart-outline": 62648,
  "pie-chart-sharp": 62649,
  "pin": 62650,
  "pin-outline": 62651,
  "pin-sharp": 62652,
  "pint": 62653,
  "pint-outline": 62654,
  "pint-sharp": 62655,
  "pizza": 62656,
  "pizza-outline": 62657,
  "pizza-sharp": 62658,
  "planet": 62659,
  "planet-outline": 62660,
  "planet-sharp": 62661,
  "play": 62662,
  "play-back": 62663,
  "play-back-circle": 62664,
  "play-back-circle-outline": 62665,
  "play-back-circle-sharp": 62666,
  "play-back-outline": 62667,
  "play-back-sharp": 62668,
  "play-circle": 62669,
  "play-circle-outline": 62670,
  "play-circle-sharp": 62671,
  "play-forward": 62672,
  "play-forward-circle": 62673,
  "play-forward-circle-outline": 62674,
  "play-forward-circle-sharp": 62675,
  "play-forward-outline": 62676,
  "play-forward-sharp": 62677,
  "play-outline": 62678,
  "play-sharp": 62679,
  "play-skip-back": 62680,
  "play-skip-back-circle": 62681,
  "play-skip-back-circle-outline": 62682,
  "play-skip-back-circle-sharp": 62683,
  "play-skip-back-outline": 62684,
  "play-skip-back-sharp": 62685,
  "play-skip-forward": 62686,
  "play-skip-forward-circle": 62687,
  "play-skip-forward-circle-outline": 62688,
  "play-skip-forward-circle-sharp": 62689,
  "play-skip-forward-outline": 62690,
  "play-skip-forward-sharp": 62691,
  "podium": 62692,
  "podium-outline": 62693,
  "podium-sharp": 62694,
  "power": 62695,
  "power-outline": 62696,
  "power-sharp": 62697,
  "pricetag": 62698,
  "pricetag-outline": 62699,
  "pricetag-sharp": 62700,
  "pricetags": 62701,
  "pricetags-outline": 62702,
  "pricetags-sharp": 62703,
  "print": 62704,
  "print-outline": 62705,
  "print-sharp": 62706,
  "prism": 62707,
  "prism-outline": 62708,
  "prism-sharp": 62709,
  "pulse": 62710,
  "pulse-outline": 62711,
  "pulse-sharp": 62712,
  "push": 62713,
  "push-outline": 62714,
  "push-sharp": 62715,
  "qr-code": 62716,
  "qr-code-outline": 62717,
  "qr-code-sharp": 62718,
  "radio": 62719,
  "radio-button-off": 62720,
  "radio-button-off-outline": 62721,
  "radio-button-off-sharp": 62722,
  "radio-button-on": 62723,
  "radio-button-on-outline": 62724,
  "radio-button-on-sharp": 62725,
  "radio-outline": 62726,
  "radio-sharp": 62727,
  "rainy": 62728,
  "rainy-outline": 62729,
  "rainy-sharp": 62730,
  "reader": 62731,
  "reader-outline": 62732,
  "reader-sharp": 62733,
  "receipt": 62734,
  "receipt-outline": 62735,
  "receipt-sharp": 62736,
  "recording": 62737,
  "recording-outline": 62738,
  "recording-sharp": 62739,
  "refresh": 62740,
  "refresh-circle": 62741,
  "refresh-circle-outline": 62742,
  "refresh-circle-sharp": 62743,
  "refresh-outline": 62744,
  "refresh-sharp": 62745,
  "reload": 62746,
  "reload-circle": 62747,
  "reload-circle-outline": 62748,
  "reload-circle-sharp": 62749,
  "reload-outline": 62750,
  "reload-sharp": 62751,
  "remove": 62752,
  "remove-circle": 62753,
  "remove-circle-outline": 62754,
  "remove-circle-sharp": 62755,
  "remove-outline": 62756,
  "remove-sharp": 62757,
  "reorder-four": 62758,
  "reorder-four-outline": 62759,
  "reorder-four-sharp": 62760,
  "reorder-three": 62761,
  "reorder-three-outline": 62762,
  "reorder-three-sharp": 62763,
  "reorder-two": 62764,
  "reorder-two-outline": 62765,
  "reorder-two-sharp": 62766,
  "repeat": 62767,
  "repeat-outline": 62768,
  "repeat-sharp": 62769,
  "resize": 62770,
  "resize-outline": 62771,
  "resize-sharp": 62772,
  "restaurant": 62773,
  "restaurant-outline": 62774,
  "restaurant-sharp": 62775,
  "return-down-back": 62776,
  "return-down-back-outline": 62777,
  "return-down-back-sharp": 62778,
  "return-down-forward": 62779,
  "return-down-forward-outline": 62780,
  "return-down-forward-sharp": 62781,
  "return-up-back": 62782,
  "return-up-back-outline": 62783,
  "return-up-back-sharp": 62784,
  "return-up-forward": 62785,
  "return-up-forward-outline": 62786,
  "return-up-forward-sharp": 62787,
  "ribbon": 62788,
  "ribbon-outline": 62789,
  "ribbon-sharp": 62790,
  "rocket": 62791,
  "rocket-outline": 62792,
  "rocket-sharp": 62793,
  "rose": 62794,
  "rose-outline": 62795,
  "rose-sharp": 62796,
  "sad": 62797,
  "sad-outline": 62798,
  "sad-sharp": 62799,
  "save": 62800,
  "save-outline": 62801,
  "save-sharp": 62802,
  "scale": 62803,
  "scale-outline": 62804,
  "scale-sharp": 62805,
  "scan": 62806,
  "scan-circle": 62807,
  "scan-circle-outline": 62808,
  "scan-circle-sharp": 62809,
  "scan-outline": 62810,
  "scan-sharp": 62811,
  "school": 62812,
  "school-outline": 62813,
  "school-sharp": 62814,
  "search": 62815,
  "search-circle": 62816,
  "search-circle-outline": 62817,
  "search-circle-sharp": 62818,
  "search-outline": 62819,
  "search-sharp": 62820,
  "send": 62821,
  "send-outline": 62822,
  "send-sharp": 62823,
  "server": 62824,
  "server-outline": 62825,
  "server-sharp": 62826,
  "settings": 62827,
  "settings-outline": 62828,
  "settings-sharp": 62829,
  "shapes": 62830,
  "shapes-outline": 62831,
  "shapes-sharp": 62832,
  "share": 62833,
  "share-outline": 62834,
  "share-sharp": 62835,
  "share-social": 62836,
  "share-social-outline": 62837,
  "share-social-sharp": 62838,
  "shield": 62839,
  "shield-checkmark": 62840,
  "shield-checkmark-outline": 62841,
  "shield-checkmark-sharp": 62842,
  "shield-half": 62843,
  "shield-half-outline": 62844,
  "shield-half-sharp": 62845,
  "shield-outline": 62846,
  "shield-sharp": 62847,
  "shirt": 62848,
  "shirt-outline": 62849,
  "shirt-sharp": 62850,
  "shuffle": 62851,
  "shuffle-outline": 62852,
  "shuffle-sharp": 62853,
  "skull": 62854,
  "skull-outline": 62855,
  "skull-sharp": 62856,
  "snow": 62857,
  "snow-outline": 62858,
  "snow-sharp": 62859,
  "sparkles": 62860,
  "sparkles-outline": 62861,
  "sparkles-sharp": 62862,
  "speedometer": 62863,
  "speedometer-outline": 62864,
  "speedometer-sharp": 62865,
  "square": 62866,
  "square-outline": 62867,
  "square-sharp": 62868,
  "star": 62869,
  "star-half": 62870,
  "star-half-outline": 62871,
  "star-half-sharp": 62872,
  "star-outline": 62873,
  "star-sharp": 62874,
  "stats-chart": 62875,
  "stats-chart-outline": 62876,
  "stats-chart-sharp": 62877,
  "stop": 62878,
  "stop-circle": 62879,
  "stop-circle-outline": 62880,
  "stop-circle-sharp": 62881,
  "stop-outline": 62882,
  "stop-sharp": 62883,
  "stopwatch": 62884,
  "stopwatch-outline": 62885,
  "stopwatch-sharp": 62886,
  "storefront": 62887,
  "storefront-outline": 62888,
  "storefront-sharp": 62889,
  "subway": 62890,
  "subway-outline": 62891,
  "subway-sharp": 62892,
  "sunny": 62893,
  "sunny-outline": 62894,
  "sunny-sharp": 62895,
  "swap-horizontal": 62896,
  "swap-horizontal-outline": 62897,
  "swap-horizontal-sharp": 62898,
  "swap-vertical": 62899,
  "swap-vertical-outline": 62900,
  "swap-vertical-sharp": 62901,
  "sync": 62902,
  "sync-circle": 62903,
  "sync-circle-outline": 62904,
  "sync-circle-sharp": 62905,
  "sync-outline": 62906,
  "sync-sharp": 62907,
  "tablet-landscape": 62908,
  "tablet-landscape-outline": 62909,
  "tablet-landscape-sharp": 62910,
  "tablet-portrait": 62911,
  "tablet-portrait-outline": 62912,
  "tablet-portrait-sharp": 62913,
  "telescope": 62914,
  "telescope-outline": 62915,
  "telescope-sharp": 62916,
  "tennisball": 62917,
  "tennisball-outline": 62918,
  "tennisball-sharp": 62919,
  "terminal": 62920,
  "terminal-outline": 62921,
  "terminal-sharp": 62922,
  "text": 62923,
  "text-outline": 62924,
  "text-sharp": 62925,
  "thermometer": 62926,
  "thermometer-outline": 62927,
  "thermometer-sharp": 62928,
  "thumbs-down": 62929,
  "thumbs-down-outline": 62930,
  "thumbs-down-sharp": 62931,
  "thumbs-up": 62932,
  "thumbs-up-outline": 62933,
  "thumbs-up-sharp": 62934,
  "thunderstorm": 62935,
  "thunderstorm-outline": 62936,
  "thunderstorm-sharp": 62937,
  "ticket": 62938,
  "ticket-outline": 62939,
  "ticket-sharp": 62940,
  "time": 62941,
  "time-outline": 62942,
  "time-sharp": 62943,
  "timer": 62944,
  "timer-outline": 62945,
  "timer-sharp": 62946,
  "today": 62947,
  "today-outline": 62948,
  "today-sharp": 62949,
  "toggle": 62950,
  "toggle-outline": 62951,
  "toggle-sharp": 62952,
  "trail-sign": 62953,
  "trail-sign-outline": 62954,
  "trail-sign-sharp": 62955,
  "train": 62956,
  "train-outline": 62957,
  "train-sharp": 62958,
  "transgender": 62959,
  "transgender-outline": 62960,
  "transgender-sharp": 62961,
  "trash": 62962,
  "trash-bin": 62963,
  "trash-bin-outline": 62964,
  "trash-bin-sharp": 62965,
  "trash-outline": 62966,
  "trash-sharp": 62967,
  "trending-down": 62968,
  "trending-down-outline": 62969,
  "trending-down-sharp": 62970,
  "trending-up": 62971,
  "trending-up-outline": 62972,
  "trending-up-sharp": 62973,
  "triangle": 62974,
  "triangle-outline": 62975,
  "triangle-sharp": 62976,
  "trophy": 62977,
  "trophy-outline": 62978,
  "trophy-sharp": 62979,
  "tv": 62980,
  "tv-outline": 62981,
  "tv-sharp": 62982,
  "umbrella": 62983,
  "umbrella-outline": 62984,
  "umbrella-sharp": 62985,
  "unlink": 62986,
  "unlink-outline": 62987,
  "unlink-sharp": 62988,
  "videocam": 62989,
  "videocam-off": 62990,
  "videocam-off-outline": 62991,
  "videocam-off-sharp": 62992,
  "videocam-outline": 62993,
  "videocam-sharp": 62994,
  "volume-high": 62995,
  "volume-high-outline": 62996,
  "volume-high-sharp": 62997,
  "volume-low": 62998,
  "volume-low-outline": 62999,
  "volume-low-sharp": 63000,
  "volume-medium": 63001,
  "volume-medium-outline": 63002,
  "volume-medium-sharp": 63003,
  "volume-mute": 63004,
  "volume-mute-outline": 63005,
  "volume-mute-sharp": 63006,
  "volume-off": 63007,
  "volume-off-outline": 63008,
  "volume-off-sharp": 63009,
  "walk": 63010,
  "walk-outline": 63011,
  "walk-sharp": 63012,
  "wallet": 63013,
  "wallet-outline": 63014,
  "wallet-sharp": 63015,
  "warning": 63016,
  "warning-outline": 63017,
  "warning-sharp": 63018,
  "watch": 63019,
  "watch-outline": 63020,
  "watch-sharp": 63021,
  "water": 63022,
  "water-outline": 63023,
  "water-sharp": 63024,
  "wifi": 63025,
  "wifi-outline": 63026,
  "wifi-sharp": 63027,
  "wine": 63028,
  "wine-outline": 63029,
  "wine-sharp": 63030,
  "woman": 63031,
  "woman-outline": 63032,
  "woman-sharp": 63033
}